import {
  FETCH_UPLOAD_PROGRESS_BAR_REQUEST,
  FETCH_UPLOAD_PROGRESS_BAR_SUCCESS,
  FETCH_UPLOAD_PROGRESS_BAR_FALUIRE,
} from './progressBarCountTypes'

const initialState = {
  loading: false,
  progressEventInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPLOAD_PROGRESS_BAR_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPLOAD_PROGRESS_BAR_SUCCESS : return {
      ...state,
      progressEventInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPLOAD_PROGRESS_BAR_FALUIRE : return {
      ...state,
      loading: false,
      progressEventInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
